import { TTranscription } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentDetailCard/components/BroadcastScheduleProgramBodySegmentDetailCardBodySegmentTranscription';
import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { usePatchClipTranscription } from '@/features/clips/api/patch-clip-transcription';

import { Transcription } from '../Transcription/Transcription';
import { TranscriptionId } from '../Transcription/types';

export type ClipTranscriptionProps = {
  transcriptions: TTranscription;
  transcriptionId?: TranscriptionId;
  seconds?: number;
  textToHighlight?: string;
  searchTextToHighlight?: string;
  setSelectedMention?: (mentionId: string) => void;
  onSelection?: (selection: string) => void;
};

export const ClipTranscription = ({
  transcriptions,
  seconds = 0,
  textToHighlight,
  searchTextToHighlight,
  setSelectedMention,
  onSelection,
}: ClipTranscriptionProps) => {
  const { mutate: updateClipTranscription } = usePatchClipTranscription();
  const { activeClip } = useBroadcastScheduleProgram();

  return (
    <Transcription
      transcriptions={transcriptions}
      seconds={seconds}
      textToHighlight={textToHighlight}
      searchTextToHighlight={searchTextToHighlight}
      setSelectedMention={setSelectedMention}
      onSelection={onSelection}
      itemStartDatetime={activeClip?.start_datetime}
      onUpdate={(transcriptionId, data) => {
        updateClipTranscription({
          id: transcriptionId,
          body: {
            asr_recognition_results: data.asrRecognitionResults,
          },
        });
      }}
    />
  );
};
